import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TCreateOrderPayoutRequest,
  TCreateOrderPayoutResponse,
} from "./createOrderPayout.schema";

export const createOrderPayout =
  (axios: IAxiosInstance) =>
  async (
    params: TCreateOrderPayoutRequest
  ): Promise<TCreateOrderPayoutResponse> => {
    const response = await axios.noRetry.post("/api/orders/payout", params);
    const resData = response.data;

    if (resData?.success) {
      return resData;
    }

    throw new Error(resData?.error || "Error creating order payout");
  };
